import { CdkStepper, StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'portal-stepper',
  templateUrl: './stepper.component.html',
  providers: [
    {
      provide: CdkStepper,
      useExisting: StepperComponent,
    },
  ],
  standalone: false,
})
export class StepperComponent extends CdkStepper implements AfterContentInit {
  @Input()
  public controls: boolean = true;

  @Input()
  public header: boolean = true;

  @Input()
  public linear: boolean = false;

  @Input()
  public get selectedIndex(): number {
    return super.selectedIndex;
  }
  public set selectedIndex(value: number) {
    super.selectedIndex = value;
  }

  @Output()
  public selectionChange: EventEmitter<StepperSelectionEvent>;

  @ViewChild('list', { static: false })
  public list: ElementRef<HTMLElement>;

  public arrowWidth: number = 50;

  ngAfterContentInit(): void {
    super.ngAfterContentInit();

    this.arrowWidth = this.calcArrowWidth();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    this.arrowWidth = this.calcArrowWidth();
  }

  private calcArrowWidth() {
    let arrowWidth = 50;

    if (this.list && this.list.nativeElement) {
      const width = this.list.nativeElement.clientWidth;

      arrowWidth = (width - 200) / this.steps.length;
    }

    return arrowWidth;
  }
}
